import { MessageBox } from 'element-ui'

/**
 * 统一危险操作确认弹窗（删除、清空、冻结等）
 *
 * @param {string} message 提示内容
 * @param {string} [title='操作确认'] 弹窗标题
 * @returns {Promise} 用户点击确认 resolve，取消/关闭 reject
 *
 * @example
 * this.$deleteConfirm('确定删除该条数据？').then(() => {
 *   // 执行删除
 * })
 */
export function deleteConfirm(message, title = '操作确认') {
  return MessageBox.confirm(message, title, {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    customClass: 'aptus-confirm-dialog',
    confirmButtonClass: 'aptus-confirm-dialog__confirm',
    cancelButtonClass: 'aptus-confirm-dialog__cancel',
    closeOnClickModal: false,
    closeOnPressEscape: true,
    showClose: true
  })
}
